<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin-bottom: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
        <template>
          <el-col :span="24">
            <h2 style="margin-top: 0;">电商活动内容</h2>
          </el-col>
        </template>
      <el-col :span="24">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
<!--          <el-tab-pane label="基本信息" name="infoData" v-loading="this.updateLoading">-->
            <div>


              <el-form
                  :model="baseInfo"
                  status-icon
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                  :rules="rules"
              >
<!--                <el-form-item label="课程名称">
                  <el-col :span="15">
                    <el-input
                        v-model="baseInfo.title"
                        placeholder="请选择课程"
                        :disabled="true"
                        style="width: 80%"
                    ></el-input>
                  </el-col>
                  <el-button
                      v-if="create"
                      type="primary"
                      size="small"
                      @click="
            search.chooseOrgVisible = true;
            searchData();
          "
                  >
                    查询
                  </el-button>
                </el-form-item>-->

                <el-form-item label="活动标题" prop="title">
                  <el-input
                      v-model="baseInfo.title"
                      placeholder="活动标题"
                      style="width: 50%"
                  ></el-input>
                </el-form-item>

                <el-form-item label="起止时间" prop="start_at">
                  <el-date-picker
                      v-model="baseInfo.start_at"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择开始时间"
                      :editable="false"
                  >
                  </el-date-picker>
<!--                  ~
                  <el-date-picker
                      v-model="baseInfo.end_at"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="23:59:59"
                      placeholder="选择结束时间"
                      :editable="false"
                  >
                  </el-date-picker>-->
                </el-form-item>

                <el-form-item label="起止时间" prop="end_at">
<!--                  <el-date-picker
                      v-model="baseInfo.start_at"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择开始时间"
                      :editable="false"
                  >
                  </el-date-picker>
                  ~-->
                  <el-date-picker
                      v-model="baseInfo.end_at"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="23:59:59"
                      placeholder="选择结束时间"
                      :editable="false"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-divider></el-divider>
                <el-form-item label="活动类型">
                  <el-radio  v-model="baseInfo.type" @change="changeType('dec_give')"  label="dec_give">满减送</el-radio>
<!--                  <el-radio  v-model="baseInfo.type" @change="changeType('dec')"  label="dec">满减</el-radio>-->
                  <el-radio  v-model="baseInfo.type" @change="changeType('give')"  label="give">实付满赠</el-radio>
                </el-form-item>

                <el-form-item label="优惠规则：">
                  <el-form-item label="">
                    <el-radio v-model="baseInfo.activity_rule"  label="ladder">阶梯优惠（例：{{ this.ruleTitleExample }}）</el-radio>
                    <el-radio v-model="baseInfo.activity_rule" :disabled="loopRuleStatus"  label="loop">循环优惠（例：每{{ this.ruleTitleExample }}）</el-radio>
                  </el-form-item>
                  <template>
                  </template>
                  <el-row class="table-col">
                    <el-col :span="4" :offset="1"  class="table-item">
                      <span class="label">满多少</span>
                    </el-col>
                    <el-col :span="4"  class="table-item">
                      <span class="label">减多少</span>
                    </el-col>
                    <el-col :span="8"  class="table-item">
                      <span class="label">送赠品</span>
                    </el-col>
                    <el-col :span="4" class="table-item">
                      <span class="label">操作</span>
                    </el-col>
                  </el-row>
                  <el-row v-for="(item,index) in baseInfo.rule_list" :key="index" class="table-col" style="border: 1px solid rgb(222 228 234);margin-top: 1em">
                    <el-col  :span="4"  class="table-item" style="border: 1px solid rgb(222 228 234);padding: 1em">
<!--                      <span class="label">{{ item2.title }}</span>
                      <span class="value">{{ item2.value }}</span>-->
                      <el-input  type="number" v-model="item.full_price" placeholder="满多少" :min="1" oninput="value=value.replace(/[^0-9.]/g,'')"
                                style="width:100%"></el-input>
                    </el-col>
                    <el-col  :span="4"  class="table-item" style="border: 1px solid rgb(222 228 234);padding: 1em">
                      <el-input  type="number" v-model="item.dec_price" :disabled="decStatus" placeholder="减多少" oninput="value=value.replace(/[^0-9.]/g,'')"  :min="0"
                                 style="width:100%"></el-input>
                    </el-col>
                    <el-col  :span="8"  class="table-item" style="border: 1px solid rgb(222 228 234);padding: 1em">
<!--                      <el-row v-for="(it,idx) in item.product_list" :key="idx" class="table-col" >
                        <el-col  :span="3" class="table-item">
                          <span>{{it.title}}</span>
                        </el-col>
                        <el-button v-bind:key="index" @click="item.product_list.splice(idx, 1)" type="small"
                                   icon="el-icon-delete" size="medium"></el-button>
                      </el-row>-->
                      <!--赠品-->
                      <div v-for="(it,idx) in item.product_list" :key="idx" class="table-col" >
                          <span>{{it.title}}【{{it.sku_title}}】</span>
                        <el-button v-bind:key="index" style="margin-left: 3%" @click="item.product_list.splice(idx, 1)" type="default"
                                   icon="el-icon-delete" size="small"></el-button>
                      </div>
                      <el-button  @click="search.chooseProductVisible = true;
          searchData(index);" type="primary" icon="el-icon-plus" size="small" :disabled="goodsAddStatus"></el-button>
                    </el-col>
                    <el-col  :span="4"  class="table-item" style="padding: 1em">
                      <template v-if="index >= 1 || baseInfo.rule_list.length>1">
                        <el-button v-bind:key="index" @click="baseInfo.rule_list.splice(index, 1)" type="danger"
                                   icon="el-icon-delete" size="medium"></el-button>
                      </template>
                    </el-col>
                  </el-row>

                  <el-col  :span="24">
                    <el-button v-if="baseInfo.activity_rule=='ladder'" @click="baseInfo.rule_list.push({full_price:'',dec_price:'',product_list:[]})" type="primary" icon="el-icon-plus"
                               size="small">添加下一级优惠
                    </el-button>
                    <span style="color:#909399"></span>
                  </el-col>
                </el-form-item>

                <el-divider></el-divider>

                <el-form-item  label="参与活动商品">
                  <el-radio v-model="baseInfo.partake_product"  label="all">全部商品参加</el-radio>
                  <el-radio v-model="baseInfo.partake_product"  label="assign">指定商品参加</el-radio>
                  <el-radio v-model="baseInfo.partake_product"  label="assign_not">指定商品不参加</el-radio>
                </el-form-item>


                <el-form-item>
                  <el-button
                      size="small"
                      type="primary"
                      @click="createBaseInfo('ruleForm')"
                      :loading="updateLoading"
                      :disabled="canEdit==2"
                  >确 定</el-button
                  >
                </el-form-item>
              </el-form>

              <el-dialog
                  title="添加赠品"
                  :visible.sync="search.chooseProductVisible"
                  :close-on-click-modal="true"
                  :before-close="addEditFormOnClose"
                  width="75%"
              >
                <el-form :inline="true" :model="search.query">
                  <!-- 模糊查询 -->
                  <el-form-item>
                    <el-input
                        size="small"
                        v-model="search.query.search"
                        placeholder="请输入标题"
                        clearable
                        @blur="searchData(now_index)"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button
                        type="primary"
                        size="small"
                        @click="
              searchData(now_index);
            "
                    >
                      查询
                    </el-button>
                  </el-form-item>
                </el-form>

                <el-tabs v-model="search.activeName" @tab-click="handleClick">
                  <el-tab-pane label="商品" name="1"></el-tab-pane>
<!--                  <el-tab-pane label="读书音频" name="6"></el-tab-pane>-->
                </el-tabs>

                <!--列表-->
                <el-table
                    border
                    :data="search.result.data"
                    highlight-current-row
                    v-loading="search.listLoading1"
                    style="..."
                    @expand-change="expandChange"
                >
                  <el-table-column type="expand" >
                    <template slot-scope="props">
                      <el-table border v-loading="search.skuListLoading" :data="props.row.breBroodsList" size="mini" style="width: 92%;margin-left: 4%;">
                        <el-table-column prop="id" label="ID" align="center"></el-table-column>
                        <el-table-column prop="sku_title" label="标题" ></el-table-column>
                        <el-table-column prop="created_at" label="图片">
                          <template slot-scope="{ row }">
                            <img :src="row.img_url" style="width: 40px" alt="" />
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="200">
                          <template slot-scope="{ row }">
                            <el-button type="primary" size="small" @click="selectProduct(row)">
                              确定
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>

                  <el-table-column prop="id" label="ID" align="center"></el-table-column>
                  <el-table-column
                      prop="title"
                      label="标题"
                      align="center"
                  ></el-table-column>
                  <el-table-column label="图片" align="center">
                    <template slot-scope="{ row }">
                      <img :src="row.img_url" style="width: 40px" alt="" />
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="pageSearchData"
                    :current-page.sync="search.query.page"
                    :page-size="search.query.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="search.result.total"
                >
                </el-pagination>
              </el-dialog>
            </div>
<!--          </el-tab-pane>-->


        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  screenProductList,
} from "@/api/coupon";

import {
  getActivityInfo,
  createActivity,
  getSkuList,
} from "@/api/productActivity";
/*import { setTimeout } from 'timers';*/

export default {
  data: function() {
    return {
      now_index: 0,
      now_sku_index: 0,//当前添加赠品的行号
      create: true,
      updateLoading: false,
      decStatus:false,
      ruleTitleExample:'满100减10【送赠品】',
      goodsAddStatus:false,
      loopRuleStatus:false,
      canEdit:this.$route.query.canEdit,
      baseInfo: {
        id: 0,
        title: "",
        type: "dec_give",
        start_at:"",
        end_at:"",
        status: 0,
        partake_product: 'all',
        activity_rule: 'ladder',
        rule_list: [{full_price:'',dec_price:'',product_list:[]}],
      },
      search: {
        skuListLoading: false,
        chooseProductVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 0,
          extra_type: 2,// 限定非排期课，0-不限（即全部），1-限定搜排期课，2-限定搜非排期课
        },
        result: {
          total: 0,
          data: [],
        },
      },

      userLevelList:[],
      query:{
        level_id:'',
        create_platform:'',
        platform:'',
        stage:'',
        page:1,
        limit:20,
        task_title:'',
        task_date:'',
        team_start_at:'',

      },
      activeName: 'infoData',
      dataLoading:true,
      listLoading:true,


      rules: {
        type: [
          { required: true, message: "请选择福袋类型", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          /*{ min: 1, max: 20, message: "最多不超过20个字", trigger: "blur" },*/
        ],
        start_at: [
          { required: true, message: "请选择活动开始时间", trigger: "blur" },
        ],
        end_at: [
          { required: true, message: "请选择活动结束时间", trigger: "blur" },
        ],
        img_url: [{ required: true, message: "请上传图片", trigger: "blur" }],
      },



      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      lockBagQuery:{
        date:'',
      },
    };
  },
  created: function() {
    /*this.getData();*/
    /*let channel = localStorage.getItem('channel_type');
    console.log(channel);
    if (channel == 1) {
      this.activeName = 'studentsListData';
      this.getStudentList();
      localStorage.setItem('channel_type', '')
    }*/
    this.getActivityInfo();
  },
  methods: {
    //基本信息
    getActivityInfo() {
      this.baseInfo.id = this.$route.query.id;
      if(this.baseInfo.id > 0){
        this.create = false;
      }
      this.loading = true;
      if(this.baseInfo.id == 0){
        return;
      }
      this.updateLoading = true;
      getActivityInfo({
        id: this.baseInfo.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.baseInfo = response.data;
          this.updateLoading = false;
          this.changeType(this.baseInfo.type)
        }
        this.loading = false;
      });
    },
    // 查询方法
    searchData(index) {
      this.now_index = index;
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "1";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 0;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.search.chooseProductVisible = false;

    },
    /**点击主表格行，获取子表格明细**/
    expandChange(val) {
      console.log(val)
      val.breBroodsList = undefined;
      this.theTargetId = val.id;
      this.theTargetTitle = val.title;
      this.search.skuListLoading = true;
      if (val.breBroodsList == undefined) {
        getSkuList({product_id: val.id}).then(res => {
          this.$set(val, 'breBroodsList', res.data.list)
          this.search.skuListLoading = false;
        })
      }
    },
    pageSearchData() {
      this.searchData(this.now_index);
    },
    selectProduct(row) {
      this.baseInfo.rule_list[this.now_index].product_list.push({give_id:row.product_id,give_object_id:row.id,title:row.title,sku_title:row.sku_title})
      this.addEditFormOnClose();
    },

    changeType(type){
      if(type == 'dec'){
        this.decStatus = false
        this.goodsAddStatus = true
        //this.loopRuleStatus = false
        this.ruleTitleExample = '满100减10';
        //如果是满减，清空赠品信息
        this.baseInfo.rule_list.forEach(function (item,index,array){
          array[index].product_list = [];
        })
      }else if(type == 'give'){
        this.decStatus = true
        this.goodsAddStatus = false
        //this.loopRuleStatus = true
        //this.baseInfo.activity_rule = 'ladder'
        this.ruleTitleExample = '实付满100送赠品';
        //如果是满送，清空减的金额信息
        this.baseInfo.rule_list.forEach(function (item,index,array){
          array[index].dec_price = '';
        })
      }else{
        this.decStatus = false
        this.goodsAddStatus = false
        this.ruleTitleExample = '满100减10【送赠品】';
        //this.loopRuleStatus = false
      }
    },

    createBaseInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if(valid){
          this.updateLoading = true;
          console.log(this.baseInfo);
          createActivity(this.baseInfo)
              .then((response) => {
                this.updateLoading = false;
                if (response.status == 2000) {
                  this.$message.success(response.message);
                  this.$router.push({
                    path: "/mall/activity/list",
                  });
                }else{
                  this.$message({
                    showClose: true,
                    message: response.message,
                    type: "error",
                  });
                }
              })
              .catch((err) => {
                console.log(err)
                this.updateLoading = false;
              });
        }else{
          return false;
        }
      });

    },
    goToTaskDetails(row){
      this.taskFormData = row
      this.innerVisible = true
      /*this.$router.push({
        path: "/clockIn/info",
        query: {id:id}
      });*/
    },
    outClose(done) {
      this.$confirm('确认关闭', '提示框').then(() => {
        done()
      }).catch(() => {

      })
    },
    editTask(){
      this.$confirm('确认保存', '提示框').then(() => {
        editAttendanceTask(this.taskFormData)
            .then((response) => {
              if (response.status == 2000) {
                this.innerVisible = false;
                this.$message.success(response.message);
              }
            })
            .catch((err) => {
              console.log(err)
              this.innerVisible = true;
            });
      }).catch(() => {

      })
    },

    //日记管理
    getRecordList(){
      this.recordListLoading = true;
      this.recordDetailLoading = true;
      this.recordQuery.attendance_id = this.baseInfo.id;
      getAttendanceRecordList(this.recordQuery).then(response => {
        this.recordList = response.data.list
        this.recordListLoading = false;
        this.recordListTotal = response.data.total;
        if(this.recordListTotal){
          this.recordDetail = this.recordList[0]
        }
        this.recordDetailLoading = false;
      });
    },

    getRecordDetail(row){
      this.recordDetail = row;
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    /*delRecord(id){
      delAttendanceRecord({id:id}).then(response=>{
        this.$message.success(response.message);
        if(response.status == 2000){
          this.getRecordList()
        }
      })
    },*/
    delRecord(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        delAttendanceRecord({id}).then(response => {
          if(response.status == 2000){
            this.getRecordList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }else{
            this.$message({
              showClose: true,
              duration: 6000,
              message: response.message,
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    getStudentList(){
      this.studentListLoading = true;
      getStudentList(this.studentQuery).then(response => {
        this.studentList = response.data.list
        this.studentListTotal = response.data.total;
        this.studentListLoading = false;
      });
    },

    goToDetails(user_id) {
      localStorage.setItem('channel_type', '1')
      this.$router.push({
        path: "/clockIn/info/student/details",
        query: {
          user_id: user_id,
          attendance_id: this.studentQuery.attendance_id
        }
      });
    },

    getDataAnalysisList(){
      this.dataAnalysisListLoading = true;
      dataAnalysisList(this.dataAnalysisQuery).then(response => {
        this.dataAnalysisList = response.data.list
        this.dataAnalysisListTotal = response.data.total;
        this.dailyTotal = response.data.daily_total;
        this.userTotal = response.data.user_total;
        this.todayDailyTotal = response.data.today_daily_total;
        this.todayUserTotal = response.data.today_user_total;
        this.yesDailyTotal = response.data.yes_daily_total;
        this.yesUserTotal = response.data.yes_user_total;
        this.dataAnalysisListLoading = false;
      });
    },

    handleClick(tab) {
      switch (tab.name) {
          //基本信息
        case 'infoData':
          this.getAttendanceInfo();
          break;
          //作业管理
        case 'taskListData':
          this.getTaskList();
          break;
        case 'diaryListData':
          this.getRecordList();
          break;
          //学员管理
        case 'studentsListData':
          this.getStudentList();
          break;
          //数据分析
        case 'dataAnalysisList':
          this.getDataAnalysisList();
          break;
      }
    },
  }
};
</script>

